define("shared/components/shared/mobile/drawer/image-card", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <p class="u--text--md u--m__b__lg" data-test-id="mobile-drawer-image-card">{{@subtitle}}</p>
  <figure class="u--m__b__lg">
    {{#if @image}}
      <img
        alt={{html-safe @imageAltText}}
        class="o--media u--m__b__lg {{if @showImageCss 'img--empty__goToDesktop'}}"
        src={{@image}}
      />
    {{/if}}
  </figure>
  */
  {
    "id": "6t7rHb36",
    "block": "[[[10,2],[14,0,\"u--text--md u--m__b__lg\"],[14,\"data-test-id\",\"mobile-drawer-image-card\"],[12],[1,[30,1]],[13],[1,\"\\n\"],[10,\"figure\"],[14,0,\"u--m__b__lg\"],[12],[1,\"\\n\"],[41,[30,2],[[[1,\"    \"],[10,\"img\"],[15,\"alt\",[28,[37,1],[[30,3]],null]],[15,0,[29,[\"o--media u--m__b__lg \",[52,[30,4],\"img--empty__goToDesktop\"]]]],[15,\"src\",[30,2]],[12],[13],[1,\"\\n\"]],[]],null],[13]],[\"@subtitle\",\"@image\",\"@imageAltText\",\"@showImageCss\"],false,[\"if\",\"html-safe\"]]",
    "moduleName": "shared/components/shared/mobile/drawer/image-card.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});